import React, { Fragment } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { DialogContent, Dialog, Grid, Typography } from "@mui/material";

import { PrimaryButton } from "../../../css components/Button";

const Card = styled(Dialog)`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export default function VerifyDialog({
  detail,
  setDetail,
  loginNavigation = false,
}) {
  const navigate = useNavigate();

  const handleClose = () => {
    setDetail(false);
  };

  return (
    <Card
      open={detail}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "fit-content !important",
        },
      }}
    >
      <DialogContent>
        <Grid container spacing={3} style={{ padding: "20px" }}>
          <Grid size={12} marginBottom={"10px"}>
            <Typography variant="h4">{detail}</Typography>
          </Grid>

          {loginNavigation && (
            <Fragment>
              <Grid size="auto" offset={{ xs: "auto" }} />

              <Grid size="auto">
                <PrimaryButton
                  onClick={() => navigate("/sign-in")}
                  variant="contained"
                >
                  Sign In
                </PrimaryButton>
              </Grid>
            </Fragment>
          )}
        </Grid>
      </DialogContent>
    </Card>
  );
}
